export const SUBMIT = 'career/register';
export const SUBMIT_SUCCESS = 'career/registerSuccess';
export const SUBMIT_ERROR = 'career/registerError';
export const SUBMIT_NETWORK_ERROR = 'auth/registerNetworkError';
